import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import PreparatoryOrdersList from "./preparatoryOrder/PreparatoryOrdersList";
import ReturnOrdersList from "./returnOrder/ReturnOrdersList";
import { Link, useSearchParams } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import ParcelsList from "./parcel/ParcelsList";
import LoaderAccessesList from "./loaderAccesses/LoaderAccessesList";
import ProductsList from "./products/ProductsList";
import CustomTabsWithParams from "../../components/widgets/customTabs/CustomTabsWithParams";

const OrdersPage = ({ orderType = 'preparatoryOrders' }) => {
    const orderSlugs = {
        'preparatoryOrders': useStoreState(state => state.actionSlugs.actionSlugsDispatcher('orders')),
        'returnOrders': useStoreState(state => state.actionSlugs.actionSlugsDispatcher('returnOrders')),
        'parcels': useStoreState(state => state.actionSlugs.actionSlugsDispatcher('parcels')),
    }
    const [searchParam] = useSearchParams();
    const key = !!searchParam.get('tab') && searchParam.get('tab') !== "undefined"
        ? searchParam.get('tab')
        : orderType;

    const orderName = key === 'preparatoryOrders' ?  'préparation' :
        key === 'returnOrders' ? 'retour':
        null;
    const pageTitle = key === 'preparatoryOrders' ?  <>Bons de {orderName} <i className="ms-4 icon-box-remove text-success" /></> :
        key === 'returnOrders' ? <>Bons de {orderName} <i className="ms-4 icon-box-add text-danger" /></>:
        key === 'parcels' ? <>Colis <i className="ms-4 fas fa-box" /></> :
        key === 'loaderAccesses' ? <>Actions prestataires logistique</> :
        key === 'products' ? <>Produits</> :
        null;

    const contentTabs = [
        {
            eventKey: "preparatoryOrders",
            title: "Bons de préparation",
            mountOnEnter: true,
            unmountOnExit: false,
            content: <PreparatoryOrdersList />
        },
        {
            eventKey: "returnOrders",
            title: "Bons de retour",
            mountOnEnter: true,
            unmountOnExit: false,
            content: <ReturnOrdersList />
        },
        {
            eventKey: "parcels",
            title: "Colis",
            mountOnEnter: true,
            unmountOnExit: true,
            content: <ParcelsList />
        },
        {
            eventKey: "loaderAccesses",
            title: "Actions prestataires logistique",
            mountOnEnter: true,
            unmountOnExit: true,
            content: <LoaderAccessesList />
        },
        {
            eventKey: "products",
            title: "Produits",
            mountOnEnter: true,
            unmountOnExit: true,
            content: <ProductsList />
        }
    ]

    return <Container fluid>
        <Row className="align-items-center mb-2">
            <Col>
                <h2 className="d-flex align-items-center mb-0">
                    {pageTitle}
                </h2>
            </Col>
            {orderName && <Col xs="auto">
                <Button variant="success" as={Link} to={orderSlugs[key]?.create}>
                    <i className="fas fa-plus"></i> &nbsp;Ajouter bon de&nbsp;{orderName}
                </Button>
            </Col>}
        </Row>
        <CustomTabsWithParams
            contentTabs={contentTabs}
            defaultActiveTabId={key}
            id="orders-tabs"
        />
    </Container>
}

export default OrdersPage;